import { Brands } from "../enums/brands";
import { Default } from "./default";
import { NutmegResidence } from "./nutmegresidence";

const APP_NAME = process.env.REACT_APP_APP_NAME;

interface AppDetailsProps {
  app: {
    name: string;
    version: string;
    description: string;
    author: string;
  };
  color: {
    primaryMain: string;
    primaryMedium: string;
    primaryDark: string;
    secondaryMain: string;
    secondaryMedium: string;
    secondaryDark: string;
    tertiaryMain: string;
    tertiaryMedium: string;
    tertiaryDark: string;
    error: string;
    warning: string;
    success: string;
    dark: string;
    light: string;
  };
  header: {
    title: string;
    description: string;
  };
  strings: {
    postButton: string;
    facilitiesButton: string;
    finePrintButton: string;
    surroundingsButton: string;
  };
  flags: {
    reservationEnabled: boolean;
  };
  gallery?: { original: string }[];
  featureList?: { title: string; isAvailable: boolean }[];
  propertyInfo: {
    description: string;
    mapUrl?: string;
  };
  roomCategories: Array<{
    id: string;
    name: string;
    shortDescription: string;
    description: string;
    gallery: { original: string }[];
    featureList: { title: string; isAvailable: boolean }[];
    pricing: {
      currency: string;
      basePrice: number;
      perNight: boolean;
    };
  }>;
  facilities: any[];
  reservationOptions: any[];
  finePrintData: any[];
  neighbourhoodData: any[];
  propertySurroundingsData: any[];
}

function getAppDetails(): AppDetailsProps {
  switch (APP_NAME) {
    case Brands.NutmegResidence:
      return NutmegResidence;

    default:
      return Default;
  }
}

export const AppDetails = getAppDetails();
export const colors = AppDetails.color;
export const BrandFlags = AppDetails.flags;
export const RoomCategories = AppDetails.roomCategories;
// Backward compatibility - default to first room category (Villa)
export const Gallery =
  AppDetails.roomCategories[0]?.gallery || AppDetails.gallery;
export const mainFeaturesList =
  AppDetails.roomCategories[0]?.featureList || AppDetails.featureList;
export const FacilityData = AppDetails.facilities;
export const ReservationOptions = AppDetails.reservationOptions;
export const FinePrintDetails = AppDetails.finePrintData;
export const NeighbourhoodData = AppDetails.neighbourhoodData;
export const PropertySurroundingsData = AppDetails.propertySurroundingsData;
